import PropTypes from 'prop-types';
import React from 'react';
import { Link } from 'react-router';
import classnames from 'classnames';

import InstagramLink from '../../components/InstagramLink';
import { barberShape } from '../../shapes';
import config from '../../../config';
import Passcode from '../../passcode';

const Barber = ({ link, barber, disabled, onClick }) => (
  <Link
    className={
      classnames('c-select-box', {
        'is-disabled': disabled,
        'is-active': barber.isActive,
      })}
    onClick={onClick}
    to={link}
  >
    <div className="u-fill-parent u-bg-white">
      <div className="c-barber">
        <div
          className="c-barber__image"
          style={{ backgroundImage: `url(${barber.thumbnail || config.fallbackBarberThumbnail})` }}
        />
        <div className="c-barber__instagram">
          <InstagramLink user={barber.instagram} />
        </div>
        <div className="c-barber__details">
          <div className="layout layout--flush layout--middle">
            <div className="layout__item u-1/2 u-1/1-large-and-up">
              <div className="c-barber__details-name">
                {barber.firstName}
              </div>
            </div>
            <div className="layout__item u-1/2 u-1/1-large-and-up">
              <div className="large-and-up-mt large-and-up-pt--">
                <div className="c-heading u-co-gray-1 zeta u-lh-1">
                  Next Available:
                </div>
                <div className="epsilon">
                  {barber.nextTimeFormatted || 'No available times'}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Passcode barber={barber} link={link} />
  </Link>
);
Barber.propTypes = {
  barber: barberShape.isRequired,
  onClick: PropTypes.func.isRequired,
  link: PropTypes.string,
  disabled: PropTypes.bool,
};
Barber.defaultProps = {
  link: '',
  disabled: false,
};

export default Barber;



// WEBPACK FOOTER //
// ./src/app/barbers/components/Barber.jsx